import firebase from 'firebase/app';
import firebaseConfig from './config';
import 'firebase/firestore';
import 'firebase/storage';

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
const db = firebase.firestore();
const { Timestamp, GeoPoint } = firebase.firestore;
export default {
  db: db,
  storage: firebase.storage(),
  Timestamp: Timestamp,
  GeoPoint: GeoPoint,
  config: firebaseConfig,
};
